import React, { useState } from "react";
import LayoutFooter from "../../inc/LayoutFooter";
import LayoutHeader from "../../inc/LayoutHeader";
import { useNavigate } from "react-router-dom";
import { RollbackOutlined } from "@ant-design/icons";
import { Layout, Col, Row } from "antd";
import { Button, Card, Form, Spin, Input } from "antd";
import { displayMessage, postAPI } from "../../../utils/common";
import { ERROR_MSG_TYPE, SUCCESS_MESSAGE } from "../../../constants/messages";
import { CREATE_LAUNDRY_ITEM } from "../../../constants/api";

function ItemAdd() {
  const { Content } = Layout;
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const createData = (values) => {
    setLoading(true);

    postAPI(
      CREATE_LAUNDRY_ITEM,
      values,
      (data) => {
        if (data.status === true) {
          navigate("/laundry/item");
          displayMessage(SUCCESS_MESSAGE, data.message);
        } else {
          displayMessage(ERROR_MSG_TYPE, data.message);
        }
        setLoading(false);
      },
      () => {
        setLoading(false);
        displayMessage(ERROR_MSG_TYPE, "Unable to save item");
      }
    );
  };

  return (
    <Layout>
      <LayoutHeader />
      <Content>
        <Card
          title="Add Laundry Item"
          extra={
            <Button onClick={() => navigate(-1)} type="primary" ghost>
              <RollbackOutlined />
            </Button>
          }
        >
          <Spin spinning={loading}>
            <Form form={form} layout="vertical" onFinish={createData}>
              <Row gutter={[16, 16]}>
                <Col span={8}>
                  <Form.Item
                    name="item_code"
                    label="Item Code"
                    rules={[{ required: true }]}
                  >
                    <Input placeholder="I001" />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    name="name"
                    label="Item Name"
                    rules={[{ required: true }]}
                  >
                    <Input placeholder="Bedsheet" />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    name="unit_rate"
                    label="Unit Rate"
                    rules={[{ required: true }]}
                  >
                    <Input type="number" placeholder="15" />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    name="current_qty"
                    label="Current qty"
                    rules={[{ required: true }]}
                  >
                    <Input type="number" placeholder="15" />
                  </Form.Item>
                </Col>
              </Row>

              <Form.Item style={{ float: "right" }}>
                <Button loading={loading} htmlType="submit" type="primary">
                  Submit
                </Button>
              </Form.Item>
            </Form>
          </Spin>
        </Card>
      </Content>
      <LayoutFooter />
    </Layout>
  );
}

export default ItemAdd;
